export default __webpack_public_path__ + "a240a8ee070064a511439cdf0a4a1be2.png";